<template>
  <div class="page-content conmon-top">
    <div class="top-nav">
      <div @click="tj = 1" :class="{'choosed' : tj == 1}">中奖统计</div>
      <div @click="tj = 2" :class="{'choosed' : tj == 2}">扫码明细</div>
    </div>
    <div class="clear"></div>
    <!-- 中奖统计 -->
    <div v-show="tj===1">
      <div class="base-input ovf-hd" style="margin-bottom: 10px;">
        <el-collapse-transition>
          <div class="search-content search-input-group common-search-formtype">
            <el-form :inline="true" :model="formInline" class="search-content-item">
              <el-form-item label="奖池:">
                <el-select v-model="formInline.type" placeholder="请选择" @change="typeChange">
                  <el-option v-for="item in drawTypes" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
        <div class="tj_prize">
          <div style="font-weight: bold;">本次活动奖品总数：{{ prizetotal }}个，剩余：{{ leaveNum }}个， 中奖人数：{{ winNum }}个 </div>
          <div v-for="prize in prizeStatic">
            <div class="prizelist">
              <div class="left w100" v-if="prize.prize_level === 1">一等奖</div>
              <div class="left w100" v-if="prize.prize_level === 2">二等奖</div>
              <div class="left w100" v-if="prize.prize_level === 3">三等奖</div>
              <div class="left w100" v-if="prize.prize_level === 4">四等奖</div>
              <div class="left w100" v-if="prize.prize_level === 5">五等奖</div>
              <div class="left w100" v-if="prize.prize_level === 6">六等奖</div>
              <div class="left w150">总奖项：{{prize.prize_num}}个</div>
              <div class="left w150">剩余：{{prize.leaveNum}}个</div>
              <div class="left w150">中奖人数：{{prize.winNum}}个</div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="base-input ovf-hd" style="margin-bottom: 10px;">
        <el-row class="search-title">
          <el-col :span="4" class="search-nav-left">
            <i class="el-icon-search" style="font-weight: bold;"></i>
            <span class="order-list-search-span">筛选查询</span>
          </el-col>
          <el-col :span="20" class="search-nav-right">
            <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
            <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
            <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
            <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
            <el-button class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
          </el-col>
        </el-row>
        <el-collapse-transition>
          <div v-show="hide" class="search-content search-input-group common-search-formtype">
            <el-form :inline="true" :model="formInline" class="search-content-item" label-width="95px">
              <el-form-item label="奖品等级:">
                <el-select v-model="formInline.prize_level" placeholder="请选择">
                  <el-option v-for="item in prizelevel" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="中奖时间:">
                <el-date-picker style="width:190px;" class="time-picker" v-model="formInline.startdate" type="datetime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker> &nbsp; 至 &nbsp;
                <el-date-picker style="width:190px;" class="time-picker" v-model="formInline.enddate" type="datetime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>
      <el-row class="search-title common-table-top">
        <el-col :span="4" style="text-align: left;">
          <i class="el-icon-document" style="font-weight: bold;"></i>
          <span class="order-list-search-span">中奖列表</span>
        </el-col>
        <el-col :span="20" class="text-align-right">
          <el-button type="primary" @click="exportAction" class="add-btn" style="float: right;">导出</el-button>
        </el-col>
      </el-row>
      <el-row class="import-data-title table-first-style">
        <el-table v-loading="loading" :data="tableData" class="table">
          <el-table-column label="中奖人员" width="260">
            <template slot-scope="scope">
              <div class="headimg">
                <img :src="scope.row.avatar?scope.row.avatar:''" alt="">
                <span>{{ scope.row.nickname }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份" v-if="type==2">
            <template slot-scope="scope">
              <div v-if="scope.row.draw_type === 2 && scope.row.draw_code !== ''">被助力人</div>
              <div v-if="scope.row.draw_type === 2 && scope.row.draw_code === ''">助力人</div>
            </template>
          </el-table-column>
          <el-table-column label="奖品等级">
            <template slot-scope="scope">
              <div v-if="scope.row.prize_level === 1">一等奖</div>
              <div v-if="scope.row.prize_level === 2">二等奖</div>
              <div v-if="scope.row.prize_level === 3">三等奖</div>
              <div v-if="scope.row.prize_level === 4">四等奖</div>
              <div v-if="scope.row.prize_level === 5">五等奖</div>
              <div v-if="scope.row.prize_level === 6">六等奖</div>
            </template>
          </el-table-column>
          <el-table-column label="奖品类型">
            <template slot-scope="scope">
              <div v-if="scope.row.prize_type === 1">实物</div>
              <div v-if="scope.row.prize_type === 2">红包</div>
              <div v-if="scope.row.prize_type === 3">优惠券</div>
              <div v-if="scope.row.prize_type === 4">积分</div>
            </template>
          </el-table-column>
          <el-table-column label="奖品内容">
            <template slot-scope="scope">
              {{ scope.row.prize_name }}
            </template>
          </el-table-column>
          <el-table-column label="中奖时间" width="130">
            <template slot-scope="scope">
              {{ scope.row.create_time | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="联系人">
            <template slot-scope="scope">
              {{ scope.row.receiver_name }}
            </template>
          </el-table-column>
          <el-table-column label="手机号码">
            <template slot-scope="scope">
              {{ scope.row.receiver_mobile }}
            </template>
          </el-table-column>
          <el-table-column label="邮寄地址" width="280">
            <template slot-scope="scope">
              {{ scope.row.lottery_address }}
            </template>
          </el-table-column>
        </el-table>
        <div class="table-foot">
          <el-pagination class="table-foot-pagination" background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="limit"
            layout="total, prev, pager, next, jumper"
            :total="totalCount">
            </el-pagination>
        </div>
      </el-row>
    </div>

    <!--扫码统计-->
    <div v-show="tj===2">
      <div class="base-input ovf-hd" style="margin-bottom: 10px;">
        <el-row class="search-title">
          <el-col :span="4" class="search-nav-left">
            <i class="el-icon-search" style="font-weight: bold;"></i>
            <span class="order-list-search-span">筛选查询</span>
          </el-col>
          <el-col :span="20" class="search-nav-right">
            <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
            <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
            <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
            <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
            <el-button class="search-btn-new" type="primary" size="small" @click="searchData_draw">查询</el-button>
          </el-col>
        </el-row>
        <el-collapse-transition>
          <div v-show="hide" class="search-content search-input-group common-search-formtype">
            <el-form :inline="true" :model="drawformInline" class="search-content-item" label-width="95px">
              <el-form-item label="扫码时间:">
                <el-date-picker style="width:190px;" class="time-picker" v-model="drawformInline.startdate" type="datetime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker> &nbsp; 至 &nbsp;
                <el-date-picker style="width:190px;" class="time-picker" v-model="drawformInline.enddate" type="datetime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="扫码结果:">
                <el-select v-model="drawformInline.draw_status" placeholder="请选择">
                  <el-option v-for="item in drawStatus" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>
      <el-row class="search-title common-table-top">
        <el-col :span="4" style="text-align: left;">
          <i class="el-icon-document" style="font-weight: bold;"></i>
          <span class="order-list-search-span">扫码列表</span>
        </el-col>
        <el-col :span="20" class="text-align-right">
          <el-button type="primary" @click="exportAction_draw" class="add-btn" style="float: right;">导出</el-button>
        </el-col>
      </el-row>
      <el-row class="import-data-title table-first-style">
        <el-table v-loading="loading" :data="drawtableData" class="table">
          <el-table-column label="参与人员">
            <template slot-scope="scope">
              <div class="headimg">
                <img :src="scope.row.avatar?scope.row.avatar:''" alt="头像">
                <span>{{ scope.row.nickname }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="扫码结果">
            <template slot-scope="scope">
              <div v-if="scope.row.draw_status === 0">未中奖</div>
              <div v-if="scope.row.draw_status === 1">已中奖</div>
            </template>
          </el-table-column>
          <el-table-column label="扫码商品">
            <template slot-scope="scope">
              {{ scope.row.productname }}
            </template>
          </el-table-column>
          <el-table-column label="扫码区域">
            <template slot-scope="scope">
              {{ scope.row.provincename }}{{ scope.row.cityname }}{{ scope.row.districtname }}
            </template>
          </el-table-column>
          <el-table-column label="扫码时间">
            <template slot-scope="scope">
              {{ scope.row.create_time | formatDate }}
            </template>
          </el-table-column>
        </el-table>
        <div class="table-foot">
          <el-pagination class="table-foot-pagination" background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="limit"
            layout="total, prev, pager, next, jumper"
            :total="drawtotalCount">
          </el-pagination>
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
import { getPrizeStatics, getActivitysStatics, exportActivitys, getDrawcodeStatics, exportDrawcodeStatic } from '@/api/activity.js'
export default {
  name: 'newGuessRiddlesStatistics',
  data () {
    return {
      tj: 1, //1中奖统计，2扫码统计
      formInlineTmp: {},
      drawTypes: [
        {
          label: '主奖池',
          value: 1
        },
        {
          label: '助力奖池',
          value: 2
        }
      ],
      prizelevel: [
        {
          label: '全部',
          value: 0
        },
        {
          label: '一等奖',
          value: 1
        },
        {
          label: '二等奖',
          value: 2
        },
        {
          label: '三等奖',
          value: 3
        },
        {
          label: '四等奖',
          value: 4
        },
        {
          label: '五等奖',
          value: 5
        },
        {
          label: '六等奖',
          value: 6
        }
      ],
      drawStatus: [
        {
          label: '全部',
          value: 0
        },
        {
          label: '已中奖',
          value: 1
        },
        {
          label: '未中奖',
          value: -1
        }
      ],
      activityID: '',
      formInline: {
        prize_level: '',
        startdate: '',
        enddate: '',
        type: 1
      },
      drawformInline: {
        draw_status: '',
        startdate: '',
        enddate: '',
      },
      type:1, //1主奖池，2助力奖池
      hide: true,
      loading: true,
      tableData: [],//列表数据
      page: 1,
      limit: 10,
      totalCount: 0,
      paginationShow: true,
      prizetotal: 0,//奖品总数
      winNum: 0,//已中奖数
      leaveNum: 0,//剩余奖品数
      prizeStatic:[],//每种奖品统计数据
      drawtotalCount: 0,
      drawtableData: [],//列表数据
      page_draw: 1,
      paginationShow_draw: true,
      loading_draw: true,
    }
  },
  methods: {
    searchData() {
      this.page = 1
      //this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.getData()
    },
    searchData_draw() {
        this.page_draw = 1
        this.getData_draw()
    },
    typeChange(v){
      this.formInline.type = v
      this.type = v
      this.page = 1
      this.getData()
      this.getPrizeData()
    },
    drawStatusChange() {
      // this.page = 1
      // this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      // this.getData()
    },
    exportAction() {
      this.activityID = this.$route.query.id
      exportActivitys(this.activityID, this.formInline).then(res => {
        this.download(res)
      })
    },
    exportAction_draw(){
      this.activityID = this.$route.query.id
      exportDrawcodeStatic(this.activityID, this.drawformInline).then(res => {
        this.download(res)
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    handleSizeChange(val) {
      this.limit = val
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    handleSizeChange_draw(val) {
        this.limit = val
    },
    handleCurrentChange_draw(page) {
        this.page_draw = page
        this.getData_draw()
    },
    getData() {
      this.paginationShow = false
      this.loading = true
      getActivitysStatics(this.$route.query.id, this.page, this.formInline).then(res => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.total
          this.paginationShow = true
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.openLoading()
    },
    getData_draw() {
      this.paginationShow_draw = false
      this.loading_draw = true
      getDrawcodeStatics(this.$route.query.id, this.page_draw, this.drawformInline).then(res => {
        if (res.data.code === 0) {
          this.drawtableData = res.data.data.list
          this.drawtotalCount = res.data.data.total
          this.paginationShow_draw = true
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.openLoading_draw()
    },
    getPrizeData() {
      this.loading = true
        getPrizeStatics(this.$route.query.id, this.type).then(res => {
        if (res.data.code === 0) {
          this.prizetotal = res.data.prizetotal,
          this.winNum = res.data.winNum,
          this.leaveNum = res.data.leaveNum,
          this.prizeStatic = res.data.data
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
      openLoading_draw() {
      setTimeout(() => {
        this.loading_draw = false
      }, 500)
    }
  },
  created() {
    this.activityID = this.$route.query.id
    this.getData()
    this.getPrizeData()
    this.getData_draw()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}

.tj_prize{
  color: #333;height: auto; background: #fff; line-height: 30px; font-size: 14px; margin-top: 24px; padding:10px 20px 10px 32px; text-align: left;
}
.prizelist{
  color: #606266;
}
.left{float:left;}
.right{float:left;}
.clear{clear: both;}
.w100{width: 100px;}
.w150{width: 150px;}
.tabdiv{ padding: 0px; font-size: 15px;  margin-bottom: 20px;}
.tabdiv div{ cursor: pointer; }
.activetab{
  border-width: 2px;
  border-style: solid;
  border-color: #1890FF;
  border-left: 0px;
  border-top: 0px;
  border-right: 0px;
  border-radius: 0px;
  padding: 5px;
}

.headimg img,.headimg span{vertical-align:middle; }
.headimg img {width: 30px;height: 30px;border-radius: 20px;margin-right: 10px; }

.top-nav{
  width: calc(100% - 40px);
  margin: 0 auto 0;
  border-bottom: 1px solid #dedede;
  height: 50px;
}
.top-nav div{
  float: left;
  height: 50px;
  line-height: 50px;
  width: 75px;
  font-size: 14px;
  cursor: pointer;
}
.choosed{
  border-bottom: 1px solid #1980FF;
}
</style>
